export default class FilterChange {
  public source: any;
  public value: any;

  constructor(source: any, value: any) {
    this.source = source;
    this.value  = value;
  }
}
